export interface ChatScrollTarget {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
  scrollTo(options: ScrollToOptions): void;
}

/** Keep new/late content at the end only while the reader is following it. */
export function createChatScroll(
  getTarget: () => ChatScrollTarget | undefined,
  update: (away: boolean) => void = () => {},
) {
  let following = true;
  /** Viewport height at the last scroll or resize handled here. */
  let height = 0;
  function distance() {
    const el = getTarget();
    return el
      ? Math.max(0, el.scrollHeight - el.clientHeight - el.scrollTop)
      : 0;
  }
  function toEnd() {
    following = true;
    const el = getTarget();
    // Explicitly instant: CSS scroll-behavior must never animate chat opening.
    if (el) {
      el.scrollTo({ top: el.scrollHeight, behavior: "instant" });
      height = el.clientHeight;
    }
    update(false);
  }
  function onScroll() {
    const el = getTarget();
    // The viewport shrank under the reader (the composer grew with a reply card): the
    // browser scrolls, but the reader did not leave the end. The resize puts it back.
    if (following && el && el.clientHeight !== height) {
      height = el.clientHeight;
      return;
    }
    const gap = distance();
    following = gap <= 48;
    update(gap > 120);
  }
  function onResize() {
    const el = getTarget();
    if (el) height = el.clientHeight;
    if (following) toEnd();
    else update(distance() > 120);
  }
  return { open: toEnd, toEnd, onScroll, onResize };
}
